/**
 * Communication domain translations
 */
export default {
  en: {
    messages: {
      with: "With",
      created_by: "Created by :owner",
      direct_message: "Direct Message",
      no_messages_yet: "No messages yet",
      loading_conversations: "Loading conversations...",
      no_conversations_found: "No conversations found.",
      loading_messages: "Loading messages...",
      no_messages: "No messages yet.",
      type_a_message: "Type a message...",
      sending: "Sending...",
      send: "Send",
      today: "Today",
      yesterday: "Yesterday",
      no_messages_start: "No messages yet. Start the conversation!",
      chatting_with: "Chatting with",
      participant: "participant",
      participants: "participants",
      live: "Live",
      responder: "Responder",
      conversations: "Conversations",
      typing_single: ":user is typing...",
      typing_double: ":user1 and :user2 are typing...",
      typing_multiple: ":user and :count others are typing...",
    },
    analytics: {
      just_now: "Just now",
      minutes_ago: ":countm ago",
      hours_ago: ":counth ago",
      days_ago: ":countd ago",
      not_available: "Analytics Not Available",
      not_available_description: "Analytics will be available after the communication is sent.",
      scheduled_delivery: "Scheduled for Delivery",
      scheduled_delivery_description: "This communication is scheduled and will be sent automatically.",
      failed_to_load: "Failed to Load Analytics",
      retry: "Retry",
      delivery_summary: "Delivery Summary",
      total_recipients: "Total Recipients",
      delivery_rate: "Delivery Rate",
      open_rate: "Open Rate",
      acknowledgment_rate: "Acknowledgment Rate",
      avg_response_time: "Avg Response Time",
      no_analytics_yet: "No Analytics Yet",
      send_to_see: "Send this communication to see analytics.",
      sent: "Sent",
      read: "Read",
      acknowledged: "Acknowledged",
      read_rate: "Read Rate",
      delivery_funnel: "Delivery Funnel",
      all: "All",
      pending: "Pending",
      sent_label: "Sent",
      read_label: "Read",
      pending_ack: "Awaiting Ack",
      acknowledged_label: "Acknowledged",
      recipients: "Recipients",
      csv: "CSV",
      excel: "Excel",
      search_recipients: "Search recipients...",
      filter_by_status: "Filter by status",
      recipient_column: "Recipient",
      status_column: "Status",
      sent_column: "Sent",
      read_column: "Read",
      acknowledged_column: "Acknowledged",
      no_recipients_match: "No recipients match the current filters.",
      recipient_count: ":count :label",
      page: "Page :current of :total",
      pending_signature: "Pending Signature",
      signed: "Signed",
      view_signature: "View Signature",
      signature_column: "Signature",
      signed_column: "Signed",
      signature_viewer_title: "Signature",
      signed_by: "Signed by :name",
      signed_on: "Signed on :date",
      signature_rate: "Signature Rate",
      funnel_chip_total: ":count total",
      funnel_chip_unique: ":count unique",
    },
    types: {
      announcement: "Announcement",
      user_notice: "HR Notice",
    },
    conversations: {
      new_conversation: "New Conversation",
      title_optional: "Title (optional)",
      title_placeholder: "e.g. Project Discussion",
      participants: "Participants",
      search_people: "Search people...",
      searching: "Searching...",
      no_people_found: "No people found.",
      create_chat: "Create Chat",
    },
    inbox: {
      title: "Inbox",
      connected: "Connected",
      mark_all_read: "Mark all read",
      all: "All",
      unread: "Unread",
      pending: "Pending",
      no_messages: "No messages",
      from: "From:",
      attachment: "attachment",
      attachments: "attachments",
      acknowledge: "Acknowledge",
      acknowledged: "Acknowledged",
      has_conversation: "Has conversation",
      view_all: "View all in Inbox",
      signature_required: "Signature Required",
      pending_acknowledgment: "Pending Acknowledgment",
      acknowledgment_level_read: "Read",
      acknowledgment_level_accepted: "Read and Accepted",
      acknowledgment_level_signed: "Read, Accepted and Signed",
    },
    detail: {
      from: "From:",
      sent: "Sent:",
      sent_by: "Sent by",
      read: "Read:",
      read_badge: "Read",
      acknowledged_on: "Acknowledged on",
      requires_acknowledgment: "Requires acknowledgment",
      attachments: "Attachments",
      download: "Download",
      acknowledgment_required: "Read confirmation",
      acknowledgment_description: "Please confirm you have read this message.",
      acknowledgment_checkbox: "I have read and understood this communication",
      comment_optional: "Comment (optional)",
      add_comment: "Add a comment...",
      acknowledging: "Acknowledging...",
      acknowledge_button: "Acknowledge",
      view_conversation: "View Conversation",
      start_conversation: "Start Conversation",
      conversations: "Conversations",
      select_conversation: "Select a conversation to respond to.",
      no_conversations_yet: "No conversations have been started for this communication yet.",
      communication_acknowledged: "Communication acknowledged",
      signature_required: "Signature Required",
      signature_description: "Check the box, then sign below.",
      sign_here: "Sign here",
      clear_signature: "Clear",
      undo_signature: "Undo",
      acknowledgment_level_read: "Read",
      acknowledgment_level_accepted: "Read and Accepted",
      acknowledgment_level_signed: "Read, Accepted and Signed",
      review_all_files_notice: "Please review all attachments before signing.",
      files_review_required: "Some attachments have not been reviewed yet. Please open each file before acknowledging.",
      file_viewed: "Viewed",
      file_not_viewed: "Not viewed",
      privacy_caption: "By confirming, the following is recorded for legal compliance: your signature, IP address, browser information, timestamp, timezone, and file review history.",
    },
    pdf_viewer: {
      loading_pages: "Loading pages...",
      page_of: "Page :current of :total",
      load_error: "Failed to load PDF pages.",
      retry: "Retry",
    },
    confirm_send: {
      title: "Send Communication?",
      description: "You are about to send this communication. This action cannot be undone.",
      recipients: "Recipients",
      user: "user",
      users: "users",
      targeting: "Targeting:",
      delivery_channels: "Delivery Channels",
      in_app_notification: "In-App Notification",
      push_notification: "Push Notification",
      email: "Email",
      warning: "This action cannot be undone. The communication will be sent to all recipients immediately.",
      cancel: "Cancel",
      sending: "Sending...",
      send_now: "Send Now",
    },
    templates: {
      title: "Templates",
      new_template: "New Template",
      edit_template: "Edit Template",
      preview: "Preview",
      search_placeholder: "Search templates...",
      all_categories: "All categories",
      no_templates_found: "No templates found",
      create_first: "Create your first template",
      placeholder: "placeholder",
      placeholders: "placeholders",
      name_required: "Name is required",
      body_required: "Body template is required",
      name: "Name",
      description: "Description",
      category: "Category",
      subject_template: "Subject Template",
      subject_placeholder: "e.g., Welcome, {first_name}!",
      placeholder_hint: "Use {placeholder} syntax for variables",
      body_template: "Body Template",
      body_placeholder: "e.g., Hello {first_name},&#10;&#10;Welcome to our platform!",
      saving: "Saving...",
      create_template: "Create Template",
      save_changes: "Save Changes",
      cancel: "Cancel",
      use_this_template: "Use This Template",
      back_to_list: "Back to List",
      delete_confirm: "Are you sure you want to delete \":name\"?",
      updating: "Updating...",
      page_of: "Page :current of :total",
      previous: "Previous",
      next: "Next",
    },
    schedule: {
      scheduled: "Scheduled",
      scheduled_for: "This communication is scheduled for",
      cancel_schedule: "Cancel Schedule",
      cancel_confirm: "Are you sure you want to cancel this schedule?",
      cancelling: "Cancelling...",
      yes_cancel: "Yes, Cancel",
      no_keep: "No, Keep",
      schedule_for_later: "Schedule for Later",
      date: "Date",
      time: "Time",
      frequency: "Frequency",
      schedule_communication: "Schedule Communication",
      scheduling: "Scheduling...",
      scheduled_time_future: "Scheduled time must be at least 5 minutes in the future.",
      scheduled_time_min_hint: "Pick a time at least 5 minutes from now.",
      frequency_once: "Once",
      frequency_daily: "Daily",
      frequency_weekly: "Weekly",
      frequency_monthly: "Monthly",
      scheduling_error: "Failed to schedule",
      cancel_error: "Failed to cancel schedule",
    },
    schedule_manager: {
      send_now: "Send Now",
      schedule_new: "Schedule New",
      send_now_description: "Send this communication immediately to selected recipients.",
      select_recipient: "Please select at least one recipient.",
      schedule: "Schedule",
      archived_unavailable: "This communication is archived and cannot be scheduled or sent.",
      date: "Date",
      time: "Time",
      executed: "Executed",
      cancelled: "Cancelled",
      pending: "Pending",
      no_scheduled_items: "No scheduled items",
      scheduled_for: "Scheduled for :date",
      executed_at: "Executed at :date",
      cancelled_at: "Cancelled at :date",
      cancel: "Cancel",
      retract: "Retract",
      retract_title: "Retract communication",
      retract_description: "Remove this message from recipient inboxes. Only available while no one has read it yet.",
      retract_blocked: "Cannot retract: at least one recipient has already read this message.",
      retract_confirm: "Retract this communication from all recipient inboxes? This cannot be undone.",
      origin_manual: "Manual send",
      origin_scheduled: "Scheduled",
      sent_manually_on: "Sent manually on :date",
      counts_total: "Recipients",
      counts_read: "Read",
      counts_acknowledged: "Acknowledged",
      targeting: "Targeting",
      payload_preview: "Message preview",
      schedule_history: "Schedule History",
      scheduled_time_future: "Scheduled time must be at least 5 minutes in the future.",
      scheduled_time_min_hint: "Pick a time at least 5 minutes from now.",
      title: "Schedule",
      send_now_recipients_description: "Select recipients for immediate send",
      schedule_recipients_description: "Select recipients for this schedule",
      channels_label: "Delivery Channels",
      channels_help: "Override channels for this schedule. Recurring schedules re-apply the override on every occurrence. Leave empty to use the announcement priority defaults.",
      channel_in_app: "In-App",
      channel_push: "Push",
      channel_email: "Email",
      responders_description: "Override conversation responders for this schedule. Recurring schedules re-apply the override on every occurrence. Leave empty to use the announcement defaults.",
    },
    analytics_page: {
      title: "Analytics",
      delivery_rate: "Delivery Rate",
      open_rate: "Open Rate",
      ack_rate: "Ack Rate",
      avg_response: "Avg Response",
      time_to_read: "Time to read",
      activity_timeline: "Activity Timeline",
      last_7_days: "Last 7 days",
      last_14_days: "Last 14 days",
      last_30_days: "Last 30 days",
      sent: "Sent",
      read: "Read",
      acknowledged: "Acknowledged",
      recipients: "recipients",
      export_csv: "Export CSV",
      export_excel: "Export Excel",
      no_recipients_status: "No recipients in this status",
      recipient: "Recipient",
      acknowledged_column: "Acknowledged",
      pending: "Pending",
      updating: "Updating...",
      export_failed: "Export failed",
    },
    recipient_types: {
      no_recipients_configured: "No recipients configured",
      all_users: "All users",
      unknown_targeting: "Unknown targeting",
    },
    recipients: {
      title: "Recipients",
      preview: "Recipients Preview",
      target_audience: "Target Audience",
      specific_users: "Specific Users",
      specific_users_description: "Select individual users",
      by_roles: "By Role",
      by_roles_description: "Target users by role",
      all_users: "All Users",
      all_users_description: "Send to everyone",
      all_users_message: "All users will receive this communication",
      all_users_description_full: "This communication will be sent to everyone in the system.",
      select_users: "Select Users",
      select_roles: "Select Roles",
      select_all: "Select all",
      deselect_all: "Deselect all",
      exclude_users: "Exclude specific users (optional)",
      search_users: "Search users...",
      search_users_exclude: "Search users to exclude...",
      type_to_search: "Type to search users...",
      searching: "Searching...",
      type_min_chars: "Type at least 2 characters to search",
      no_users_found: "No users found",
      users: "Users",
      selected: "Selected",
      users_selected: ":count / :max users selected",
      maximum_selected: "Maximum :max users selected",
      more: "+:count more",
      configure_preview: "Configure recipients above to see a preview",
      calculating: "Calculating recipients...",
      preview_failed: "Failed to preview recipients",
      no_users_match: "No users match this criteria",
      try_different: "Try selecting different users or roles",
      recipient: "recipient",
      recipients_plural: "recipients",
      large_audience: "Large audience",
      show_sample: "Show sample recipients",
      hide_sample: "Hide sample recipients",
      cannot_modify: "Recipients cannot be modified after the communication has been sent.",
      role: "role",
      roles: "roles",
      user: "user",
      users_plural: "users",
      total: "total",
      roles_selected: ":count :role selected",
      no_roles_available: "No roles available",
      failed_to_load_roles: "Failed to load roles",
      try_again: "Try again",
      user_fallback: "User :id",
    },
    responders: {
      title: "Conversation Responders",
      description: "Select who will be automatically added to conversations when recipients reply.",
      search_users: "Search users to add as responders...",
      preview: "Responders Preview",
      configure_preview: "Select roles or users above to see a preview",
      calculating: "Resolving responders...",
      preview_failed: "Failed to preview responders",
      no_responders_match: "No responders match the selected criteria",
      responder: "responder",
      responders_plural: "responders",
      cannot_modify: "Responders cannot be modified after the communication has been sent.",
      permissions: "Responder Permissions",
      can_view: "Can view conversation messages",
      can_reply: "Can reply to conversations",
      none_summary: "No responders",
    },
    tour: {
      inbox_header_title: "Your Inbox",
      inbox_header_desc: "All your communications appear here. The badge shows your unread count.",
      filters_title: "Filter Messages",
      filters_desc: "Quickly switch between all messages, unread only, or those pending your acknowledgment.",
      list_title: "Message List",
      list_desc: "Click any message to read it. Unread messages have a blue dot. Urgent items are highlighted.",
    },
    toasts: {
      scheduled: "Communication scheduled",
      schedule_cancelled: "Schedule cancelled",
      retracted: "Communication retracted",
      sent: "Communication sent",
    },
  },
  fr: {
    messages: {
      with: "Avec",
      created_by: "Créé par :owner",
      direct_message: "Message direct",
      no_messages_yet: "Aucun message pour le moment",
      loading_conversations: "Chargement des conversations...",
      no_conversations_found: "Aucune conversation trouvée.",
      loading_messages: "Chargement des messages...",
      no_messages: "Aucun message pour le moment.",
      type_a_message: "Tapez un message...",
      sending: "Envoi...",
      send: "Envoyer",
      today: "Aujourd'hui",
      yesterday: "Hier",
      no_messages_start: "Aucun message pour le moment. Commencez la conversation !",
      chatting_with: "Discussion avec",
      participant: "participant",
      participants: "participants",
      live: "En direct",
      responder: "Répondeur",
      conversations: "Conversations",
      typing_single: ":user est en train d'écrire...",
      typing_double: ":user1 et :user2 sont en train d'écrire...",
      typing_multiple: ":user et :count autres sont en train d'écrire...",
    },
    analytics: {
      just_now: "À l'instant",
      minutes_ago: "il y a :countm",
      hours_ago: "il y a :counth",
      days_ago: "il y a :countj",
      not_available: "Analyses non disponibles",
      not_available_description: "Les analyses seront disponibles après l'envoi de la communication.",
      scheduled_delivery: "Planifié pour l'envoi",
      scheduled_delivery_description: "Cette communication est planifiée et sera envoyée automatiquement.",
      failed_to_load: "Échec du chargement des analyses",
      retry: "Réessayer",
      delivery_summary: "Résumé de livraison",
      total_recipients: "Total des destinataires",
      delivery_rate: "Taux de livraison",
      open_rate: "Taux d'ouverture",
      acknowledgment_rate: "Taux de confirmation",
      avg_response_time: "Temps de réponse moyen",
      no_analytics_yet: "Aucune analyse pour le moment",
      send_to_see: "Envoyez cette communication pour voir les analyses.",
      sent: "Envoyé",
      read: "Lu",
      acknowledged: "Confirmé",
      read_rate: "Taux de lecture",
      delivery_funnel: "Entonnoir de livraison",
      all: "Tous",
      pending: "En attente",
      sent_label: "Envoyé",
      read_label: "Lu",
      pending_ack: "En attente de confirmation",
      acknowledged_label: "Confirmé",
      recipients: "Destinataires",
      csv: "CSV",
      excel: "Excel",
      search_recipients: "Rechercher des destinataires...",
      filter_by_status: "Filtrer par statut",
      recipient_column: "Destinataire",
      status_column: "Statut",
      sent_column: "Envoyé",
      read_column: "Lu",
      acknowledged_column: "Confirmé",
      no_recipients_match: "Aucun destinataire ne correspond aux filtres actuels.",
      recipient_count: ":count :label",
      page: "Page :current sur :total",
      pending_signature: "Signature en attente",
      signed: "Signé",
      view_signature: "Voir la signature",
      signature_column: "Signature",
      signed_column: "Signé",
      signature_viewer_title: "Signature",
      signed_by: "Signé par :name",
      signed_on: "Signé le :date",
      signature_rate: "Taux de signature",
      funnel_chip_total: ":count au total",
      funnel_chip_unique: ":count uniques",
    },
    types: {
      announcement: "Annonce",
      user_notice: "Avis RH",
    },
    conversations: {
      new_conversation: "Nouvelle conversation",
      title_optional: "Titre (optionnel)",
      title_placeholder: "ex. Discussion de projet",
      participants: "Participants",
      search_people: "Rechercher des personnes...",
      searching: "Recherche...",
      no_people_found: "Aucune personne trouvée.",
      create_chat: "Créer une discussion",
    },
    inbox: {
      title: "Boîte de réception",
      connected: "Connecté",
      mark_all_read: "Tout marquer comme lu",
      all: "Tout",
      unread: "Non lu",
      pending: "En attente",
      no_messages: "Aucun message",
      from: "De :",
      attachment: "pièce jointe",
      attachments: "pièces jointes",
      acknowledge: "Confirmer",
      acknowledged: "Confirmé",
      has_conversation: "A une conversation",
      view_all: "Voir tout dans la boîte de réception",
      signature_required: "Signature requise",
      pending_acknowledgment: "En attente d'acceptation",
      acknowledgment_level_read: "Lu",
      acknowledgment_level_accepted: "Lu et accepté",
      acknowledgment_level_signed: "Lu, accepté et signé",
    },
    detail: {
      from: "De :",
      sent: "Envoyé :",
      sent_by: "Envoyé par",
      read: "Lu :",
      read_badge: "Lu",
      acknowledged_on: "Confirmé le",
      requires_acknowledgment: "Nécessite une confirmation",
      attachments: "Pièces jointes",
      download: "Télécharger",
      acknowledgment_required: "Confirmation de lecture",
      acknowledgment_description: "Merci de confirmer votre lecture.",
      acknowledgment_checkbox: "J'ai lu et compris cette communication",
      comment_optional: "Commentaire (optionnel)",
      add_comment: "Ajouter un commentaire...",
      acknowledging: "Confirmation...",
      acknowledge_button: "Confirmer",
      view_conversation: "Voir la conversation",
      start_conversation: "Démarrer une conversation",
      conversations: "Conversations",
      select_conversation: "Sélectionnez une conversation à laquelle répondre.",
      no_conversations_yet: "Aucune conversation n'a encore été démarrée pour cette communication.",
      communication_acknowledged: "Communication confirmée",
      signature_required: "Signature requise",
      signature_description: "Cochez la case, puis signez ci-dessous.",
      sign_here: "Signez ici",
      clear_signature: "Effacer",
      undo_signature: "Annuler le trait",
      acknowledgment_level_read: "Lu",
      acknowledgment_level_accepted: "Lu et accepté",
      acknowledgment_level_signed: "Lu, accepté et signé",
      review_all_files_notice: "Veuillez consulter toutes les pièces jointes avant de signer.",
      files_review_required: "Certaines pièces jointes n'ont pas encore été consultées. Veuillez ouvrir chaque fichier avant de confirmer.",
      file_viewed: "Consulté",
      file_not_viewed: "Non consulté",
      privacy_caption: "En confirmant, les informations suivantes sont enregistrées à des fins juridiques : votre signature, adresse IP, informations du navigateur, horodatage, fuseau horaire et historique de consultation des fichiers.",
    },
    pdf_viewer: {
      loading_pages: "Chargement des pages...",
      page_of: "Page :current sur :total",
      load_error: "Échec du chargement des pages PDF.",
      retry: "Réessayer",
    },
    confirm_send: {
      title: "Envoyer la communication ?",
      description: "Vous êtes sur le point d'envoyer cette communication. Cette action est irréversible.",
      recipients: "Destinataires",
      user: "utilisateur",
      users: "utilisateurs",
      targeting: "Ciblage :",
      delivery_channels: "Canaux de livraison",
      in_app_notification: "Notification dans l'application",
      push_notification: "Notification push",
      email: "E-mail",
      warning: "Cette action est irréversible. La communication sera envoyée à tous les destinataires immédiatement.",
      cancel: "Annuler",
      sending: "Envoi...",
      send_now: "Envoyer maintenant",
    },
    templates: {
      title: "Modèles",
      new_template: "Nouveau modèle",
      edit_template: "Modifier le modèle",
      preview: "Aperçu",
      search_placeholder: "Rechercher des modèles...",
      all_categories: "Toutes les catégories",
      no_templates_found: "Aucun modèle trouvé",
      create_first: "Créez votre premier modèle",
      placeholder: "espace réservé",
      placeholders: "espaces réservés",
      name_required: "Le nom est requis",
      body_required: "Le modèle de corps est requis",
      name: "Nom",
      description: "Description",
      category: "Catégorie",
      subject_template: "Modèle d'objet",
      subject_placeholder: "ex. Bienvenue, {first_name} !",
      placeholder_hint: "Utilisez la syntaxe {placeholder} pour les variables",
      body_template: "Modèle de corps",
      body_placeholder: "ex. Bonjour {first_name},&#10;&#10;Bienvenue sur notre plateforme !",
      saving: "Enregistrement...",
      create_template: "Créer le modèle",
      save_changes: "Enregistrer les modifications",
      cancel: "Annuler",
      use_this_template: "Utiliser ce modèle",
      back_to_list: "Retour à la liste",
      delete_confirm: "Êtes-vous sûr de vouloir supprimer \":name\" ?",
      updating: "Mise à jour...",
      page_of: "Page :current sur :total",
      previous: "Précédent",
      next: "Suivant",
    },
    schedule: {
      scheduled: "Planifié",
      scheduled_for: "Cette communication est planifiée pour",
      cancel_schedule: "Annuler la planification",
      cancel_confirm: "Êtes-vous sûr de vouloir annuler cette planification ?",
      cancelling: "Annulation...",
      yes_cancel: "Oui, annuler",
      no_keep: "Non, garder",
      schedule_for_later: "Planifier pour plus tard",
      date: "Date",
      time: "Heure",
      frequency: "Fréquence",
      schedule_communication: "Planifier la communication",
      scheduling: "Planification...",
      scheduled_time_future: "L'heure planifiée doit être au moins 5 minutes dans le futur.",
      scheduled_time_min_hint: "Choisissez une heure au moins 5 minutes après maintenant.",
      frequency_once: "Une fois",
      frequency_daily: "Quotidien",
      frequency_weekly: "Hebdomadaire",
      frequency_monthly: "Mensuel",
      scheduling_error: "Échec de la planification",
      cancel_error: "Échec de l'annulation de la planification",
    },
    schedule_manager: {
      send_now: "Envoyer maintenant",
      schedule_new: "Planifier nouveau",
      send_now_description: "Envoyer cette communication immédiatement aux destinataires sélectionnés.",
      select_recipient: "Veuillez sélectionner au moins un destinataire.",
      schedule: "Planifier",
      archived_unavailable: "Cette communication est archivée et ne peut pas être planifiée ou envoyée.",
      date: "Date",
      time: "Heure",
      executed: "Exécuté",
      cancelled: "Annulé",
      pending: "En attente",
      no_scheduled_items: "Aucun élément planifié",
      scheduled_for: "Planifié pour :date",
      executed_at: "Exécuté le :date",
      cancelled_at: "Annulé le :date",
      cancel: "Annuler",
      retract: "Retirer",
      retract_title: "Retirer la communication",
      retract_description: "Retirer ce message des boîtes de réception. Disponible tant qu’aucun destinataire ne l’a encore lu.",
      retract_blocked: "Retrait impossible : au moins un destinataire a déjà lu ce message.",
      retract_confirm: "Retirer cette communication de toutes les boîtes de réception ? Cette action est irréversible.",
      origin_manual: "Envoi manuel",
      origin_scheduled: "Planifié",
      sent_manually_on: "Envoyé manuellement le :date",
      counts_total: "Destinataires",
      counts_read: "Lu",
      counts_acknowledged: "Accusé de réception",
      targeting: "Ciblage",
      payload_preview: "Aperçu du message",
      schedule_history: "Historique des planifications",
      scheduled_time_future: "L'heure planifiée doit être au moins 5 minutes dans le futur.",
      scheduled_time_min_hint: "Choisissez une heure au moins 5 minutes après maintenant.",
      title: "Planification",
      send_now_recipients_description: "Sélectionner les destinataires pour l'envoi immédiat",
      schedule_recipients_description: "Sélectionner les destinataires pour cette planification",
      channels_label: "Canaux de livraison",
      channels_help: "Remplace les canaux pour cette planification. Pour une planification récurrente, le remplacement s'applique à chaque occurrence. Laisser vide pour utiliser les valeurs par défaut selon la priorité de l'annonce.",
      channel_in_app: "Dans l'app",
      channel_push: "Push",
      channel_email: "Courriel",
      responders_description: "Remplace les répondants de conversation pour cette planification. Pour une planification récurrente, le remplacement s'applique à chaque occurrence. Laisser vide pour utiliser ceux de l'annonce.",
    },
    analytics_page: {
      title: "Analyses",
      delivery_rate: "Taux de livraison",
      open_rate: "Taux d'ouverture",
      ack_rate: "Taux de confirmation",
      avg_response: "Réponse moyenne",
      time_to_read: "Temps de lecture",
      activity_timeline: "Chronologie des activités",
      last_7_days: "7 derniers jours",
      last_14_days: "14 derniers jours",
      last_30_days: "30 derniers jours",
      sent: "Envoyé",
      read: "Lu",
      acknowledged: "Confirmé",
      recipients: "destinataires",
      export_csv: "Exporter CSV",
      export_excel: "Exporter Excel",
      no_recipients_status: "Aucun destinataire dans ce statut",
      recipient: "Destinataire",
      acknowledged_column: "Confirmé",
      pending: "En attente",
      updating: "Mise à jour...",
      export_failed: "Échec de l'exportation",
    },
    recipient_types: {
      no_recipients_configured: "Aucun destinataire configuré",
      all_users: "Tous les utilisateurs",
      unknown_targeting: "Ciblage inconnu",
    },
    recipients: {
      title: "Destinataires",
      preview: "Aperçu des destinataires",
      target_audience: "Public cible",
      specific_users: "Employés spécifiques",
      specific_users_description: "Sélectionner des utilisateurs individuels",
      by_roles: "Par rôle",
      by_roles_description: "Cibler les utilisateurs par rôle",
      all_users: "Tous les utilisateurs",
      all_users_description: "Envoyer à tout le monde",
      all_users_message: "Tous les utilisateurs recevront cette communication",
      all_users_description_full: "Cette communication sera envoyée à tous les utilisateurs du système.",
      select_users: "Sélectionner les utilisateurs",
      select_roles: "Sélectionner les rôles",
      select_all: "Tout sélectionner",
      deselect_all: "Tout désélectionner",
      exclude_users: "Exclure des utilisateurs spécifiques (optionnel)",
      search_users: "Rechercher des utilisateurs...",
      search_users_exclude: "Rechercher des utilisateurs à exclure...",
      type_to_search: "Tapez pour rechercher des utilisateurs...",
      searching: "Recherche...",
      type_min_chars: "Tapez au moins 2 caractères pour rechercher",
      no_users_found: "Aucun utilisateur trouvé",
      users: "Employés",
      selected: "Sélectionné",
      users_selected: ":count / :max utilisateurs sélectionnés",
      maximum_selected: "Maximum :max utilisateurs sélectionnés",
      more: "+:count de plus",
      configure_preview: "Configurez les destinataires ci-dessus pour voir un aperçu",
      calculating: "Calcul des destinataires...",
      preview_failed: "Échec de l'aperçu des destinataires",
      no_users_match: "Aucun utilisateur ne correspond à ces critères",
      try_different: "Essayez de sélectionner différents utilisateurs ou rôles",
      recipient: "destinataire",
      recipients_plural: "destinataires",
      large_audience: "Grande audience",
      show_sample: "Afficher un échantillon de destinataires",
      hide_sample: "Masquer l'échantillon de destinataires",
      cannot_modify: "Les destinataires ne peuvent pas être modifiés après l'envoi de la communication.",
      role: "rôle",
      roles: "rôles",
      user: "utilisateur",
      users_plural: "utilisateurs",
      total: "total",
      roles_selected: ":count :role sélectionné",
      no_roles_available: "Aucun rôle disponible",
      failed_to_load_roles: "Échec du chargement des rôles",
      try_again: "Réessayer",
      user_fallback: "Employé :id",
    },
    responders: {
      title: "Répondants de conversation",
      description: "Sélectionnez qui sera automatiquement ajouté aux conversations lorsque les destinataires répondent.",
      search_users: "Rechercher des utilisateurs à ajouter comme Répondants...",
      preview: "Aperçu des Répondants",
      configure_preview: "Sélectionnez des rôles ou des utilisateurs ci-dessus pour voir un aperçu",
      calculating: "Résolution des Répondants...",
      preview_failed: "Échec de l'aperçu des Répondants",
      no_responders_match: "Aucun répondeur ne correspond aux critères sélectionnés",
      responder: "répondeur",
      responders_plural: "Répondants",
      cannot_modify: "Les répondants ne peuvent pas être modifiés après l'envoi de la communication.",
      permissions: "Autorisations des Répondants",
      can_view: "Peut visualiser les messages de conversation",
      can_reply: "Peut répondre aux conversations",
      none_summary: "Aucun répondant",
    },
    tour: {
      inbox_header_title: "Votre boîte de réception",
      inbox_header_desc: "Toutes vos communications apparaissent ici. Le badge indique le nombre de messages non lus.",
      filters_title: "Filtrer les messages",
      filters_desc: "Basculez rapidement entre tous les messages, les non lus uniquement, ou ceux en attente de votre accusé de réception.",
      list_title: "Liste des messages",
      list_desc: "Cliquez sur un message pour le lire. Les messages non lus ont un point bleu. Les éléments urgents sont mis en évidence.",
    },
    toasts: {
      scheduled: "Communication planifiée",
      schedule_cancelled: "Planification annulée",
      retracted: "Communication retirée",
      sent: "Communication envoyée",
    },
  },
};
